module.exports = __webpack_public_path__ + "media/images/logo-everfactor-banner-8d91485c60a852c7d177849d2795c36d.png";